import { Box, CircleDot, Globe2, Magnet, MousePointer2, Sun, Video } from 'lucide-react';
import { useState } from 'react';
import { useEditorStore } from '../../store/editorStore';
import { CompositionBreadcrumbs } from '../layout/Breadcrumbs';
import { PreviewCanvas } from './PreviewCanvas';
import { PreviewToolbar } from './PreviewToolbar';

export function PreviewPanel() {
  const [safeZones, setSafeZones] = useState(false);
  const [grid, setGrid] = useState(false);
  const workspace = useEditorStore((state) => state.workspace);
  return <section className="preview-panel">
    <div className="preview-header"><CompositionBreadcrumbs />{workspace === '3d' && <div className="viewport-mode"><button className="is-active"><Globe2 size={12} /> World</button><button>Local</button></div>}<div className="preview-head-spacer" /></div>
    {workspace === '3d' && <div className="three-toolbar"><button className="is-active"><MousePointer2 size={15} /> Select</button><button><Box size={15} /> Add</button><button><Sun size={15} /> Lights</button><button><Video size={15} /> Camera</button><span /><button><Magnet size={14} /> Snap</button><button><CircleDot size={14} /> Shaded</button></div>}
    <PreviewCanvas safeZones={safeZones} grid={grid} />
    <PreviewToolbar safeZones={safeZones} setSafeZones={setSafeZones} grid={grid} setGrid={setGrid} />
  </section>;
}
